import React from 'react'
import { Field } from 'redux-form';
import { BooleanInput, NumberInput, ReferenceInput, SelectInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  dropdown: {
    minWidth: 230
  },
  template: {
    width: '100%'
  }
});

type Props = {
  baseName: string,
  classes: any,
  record: any
};

const ProductTemplateSettings = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.baseName}.product_creative_attributes.product_match_content`} source={`${props.baseName}.product_creative_attributes.product_match_content`} component={BooleanInput} label="Product match content" />
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ flex: 1 }}>
        <Field name={`${props.baseName}.product_creative_attributes.nb_template_products`} source={`${props.baseName}.product_creative_attributes.nb_template_products`} component={NumberInput} label="Number of Products" />
      </div>
      <div style={{ flex: 1 }}>
        <Field name={`${props.baseName}.product_creative_attributes.selection_in_nth_products`} source={`${props.baseName}.product_creative_attributes.selection_in_nth_products`} component={NumberInput} label="Product Pool Size" />
      </div>
    </div><br />

    <Field name={`${props.baseName}.product_creative_attributes.creative_template`} source={`${props.baseName}.product_creative_attributes.creative_template`} component={ReferenceInput} label="Select Creative Template *" resource="campaign_sites" reference="helpers/creative_templates" sort={{ field: 'name', order: 'ASC' }} className={props.classes.dropdown} allowEmpty record={props.record}>
      <Field name={`${props.baseName}.product_creative_attributes.creative_template`} source={`${props.baseName}.product_creative_attributes.creative_template`} component={SelectInput} className={props.classes.template} />
    </Field><br /><br />
  </div>
);

export default withStyles(styles)(ProductTemplateSettings);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/ProductTemplateSettings.tsx